import fetch from '@rd-web-markets/shared/dist/services/Fetcher';
import { request } from '@rd-web-markets/shared/dist/services/request';
import QueryString from 'query-string';
const projectAssessmentProgressBySubsidiaryCompaniesService = {
  all(companyId, businessUnits, subsidiary_company_ids, selectedYears) {
    const query = QueryString.stringify({
      business_units: businessUnits,
      selected_years: selectedYears,
      subsidiary_company_ids: subsidiary_company_ids
    }, {
      arrayFormat: 'comma'
    });
    return fetch("/api/companies/".concat(companyId, "/project_assessment_progress_by_subsidiary_companies?").concat(query), request.get);
  }
};
export default projectAssessmentProgressBySubsidiaryCompaniesService;